import { render, staticRenderFns } from "./SSBrandSelector.vue?vue&type=template&id=346411f6&scoped=true&"
import script from "./SSBrandSelector.vue?vue&type=script&lang=js&"
export * from "./SSBrandSelector.vue?vue&type=script&lang=js&"
import style0 from "./SSBrandSelector.vue?vue&type=style&index=0&id=346411f6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "346411f6",
  null
  
)

export default component.exports